function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  filter: "url(#timer-green_svg__filter0_d)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 43.514,
  cy: 42.867,
  r: 27.867,
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 55.897c6.653 0 12.045-5.392 12.045-12.045 0-6.652-5.392-12.044-12.044-12.044S31.956 37.2 31.956 43.852c0 6.653 5.393 12.045 12.045 12.045zM44.001 28.18v2.12M41.111 27.505h5.782M43.952 36.625v7.13M50.023 43.756h-6.07",
  stroke: "#50A684",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "timer-green_svg__filter0_d",
  x: 0.647,
  y: 0,
  width: 85.735,
  height: 85.735,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 7.5
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0 0.270588 0 0 0 0.15 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));
function SvgTimerGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 87 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgTimerGreen;